/**
 * 向后端请求用户的菜单，动态生成路由
 */
import { constantRouterMap } from '@/config/router.config'
import { generatorDynamicRouter } from '@/router/generator-routers'

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    menus: []
  },
  mutations: {
    SET_ROUTERS: (state, res) => {
      state.menus = constantRouterMap.concat(res.menus || [])
      // 仅动态路由交给 addRoutes，避免重复注册常量路由
      state.addRouters = res.routers || []
      state.routers = constantRouterMap.concat(state.addRouters)
    },
    RESET_ROUTERS: (state) => {
      state.routers = constantRouterMap
      state.addRouters = []
      state.menus = []
    }
  },
  actions: {
    GenerateRoutes ({ commit }, data) {
      return new Promise(resolve => {
        generatorDynamicRouter(data).then((res) => {
          commit('SET_ROUTERS', res)
          resolve(res)
        })
      })
    }
  }
}

export default permission
